// Base JS exports for dvla-external-frontend
//
// Shakapacker consumers: this file is the webpack entry point, resolved directly.
// Precompiled assets consumers: rollup builds this into dist/ bundles (e.g. dist/dvla-external-frontend.js)
// which are shipped via the dvla-external-frontend-assets gem and served via the Rails asset pipeline.
/* sonarjs/S7763: Disable - Disabling reexport from, as it's messier */

import { initAll as GOVUKInitAll } from 'govuk-frontend';

// Base components - available to all products
import * as ClearCookies from './shared/ClearCookies';
import ProgressiveDisclosure from './shared/ProgressiveDisclosure';
import Webchat from './shared/Webchat';
import initTimeoutDialog from './timeout-dialog/TimeoutDialog';

/**
 * Initialize all required components
 */
const initializeApplication = () => {
    GOVUKInitAll(); // Initialize GOV.UK frontend components
    ClearCookies.init(); // Initialize cookie management
    ProgressiveDisclosure(); // Initialize progressive disclosure component
    Webchat(); // Initialize webchat component
    initTimeoutDialog(); // Initialize session timeout dialog
};

// Re-exports
export { ClearCookies, GOVUKInitAll, initTimeoutDialog, initializeApplication, ProgressiveDisclosure, Webchat };
